var _require = require('./dist/plugin/wrapPageElement'),
    wrapPageElement = _require.wrapPageElement;

exports.wrapPageElement = wrapPageElement;